import { render } from "./PageHeader.vue?vue&type=template&id=2c18fe17&scoped=true&ts=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=2c18fe17&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c18fe17"]])

export default __exports__